
<div class="ipm-otp-verification-section">
    <div class="ipm-heading-model-section">
        <h3 *ngIf="type === 'mobileOtp'">{{ userInfo?.channel === 'sms' ? 'Verify Mobile Number' : 'Verify WhatsApp Number' }}</h3>
        <h3 *ngIf="type !== 'mobileOtp'">Verify Email</h3>
        <ng-container *ngIf="type === 'mobileOtp' || type === 'emailOtp' || userInfo?.callingForm === 'signin' || userInfo?.callingForm === 'guest-checkout'">
            <div class="ipm-close-icon" (click)="closeByDeviceType()">
                <i class="pi pi-times"></i>
            </div>
        </ng-container>
    </div>
    <div class="ipm-otp-verification-body">
        <p class="ipm-sub-heading" *ngIf="userInfo?.isGuestAccountExists">
            An account already exists with this email. Please sign in by entering the OTP to securely complete your checkout.
        </p>
        <div class="error-message-data" *ngIf="shakeAnimation.errorMessage">
            {{shakeAnimation.errorMessage}}
        </div>
        
        <ng-container *ngIf="type === 'mobileOtp'">
            <p class="ipm-sub-heading" *ngIf="userInfo?.channel === 'whatsapp'">
                Mobile verification is required to download beats.
            </p>
            <p class="ipm-sub-heading" *ngIf="userInfo?.channel === 'sms'">
                Mobile verification is required.
            </p>
            <p class="ipm-otp-sent-text">
                {{ userInfo?.channel === 'sms' ? 'OTP has been sent to your mobile number via SMS.' : 'OTP has been sent to your WhatsApp.' }}
            </p>
        </ng-container>

        <p class="ipm-sub-heading" *ngIf="type === 'mobileOtp'; else OtherTypes; ">
            Enter the {{ userInfo?.channel === 'sms' ? '' : '6-digit ' }}OTP sent to your {{ userInfo?.channel === 'sms' ? 'mobile number' : 'WhatsApp number' }} {{userInfo?.mobileNumber?.isd}} {{userInfo?.mobileNumber?.number}}
        </p>
        <ng-template #OtherTypes>
            <p class="ipm-sub-heading">
                Enter the 6-digit OTP sent to your email<br>
                {{userInfo?.email}}
            </p>
        </ng-template>

        <div class="custom-form m-0">
             <div class="form-group custom-form-group mb-0 ipm-icon-more">
                <input [type]="isOtpVisible ? 'text' : 'password'" 
                    class="form-control"  
                    id="combinedOtpInput" 
                    name="combinedOtpInput"
                    [(ngModel)]="combinedOtp" 
                    (keypress)="formService.keyPressNumber($event)"
                    (ngModelChange)="onCombinedOtpChange($event)"
                    [attr.maxlength]="userInfo?.channel === 'sms' ? null : 6"
                    autocomplete="one-time-code"
                    inputmode="numeric"
                    [readonly]="isReadOnly"
                    (focus)="isReadOnly = false"
                    data-1p-ignore
                    data-lpignore="true">
                <div class="eye-icon" (click)="isOtpVisible = !isOtpVisible">
                    <i class="lar" [class.la-eye]="isOtpVisible" [class.la-eye-slash]="!isOtpVisible"></i>
                </div>
            </div>
        </div>
        <div class="ipm-send-Verification">
            <span >{{countdown === 0 ? 'Didn’t receive the code?' : 'You can resend the OTP in'}} <button (click)="resendOtp()"  class="resend-btn" *ngIf="countdown === 0">Resend</button> <span *ngIf="countdown !== 0" class="count-text">{{countdown}} Sec</span></span>
        </div>
        
        <div class="edit-number-section" *ngIf="type === 'mobileOtp'">
            <button class="edit-number-btn" (click)="closeByDeviceType()">Edit number</button>
        </div>
        <div class="ipm-actions mt-3">
            <ng-container *ngIf="!type; else mobileOtpTemplate">
                 <button mat-flat-button
                    color="primary"
                    class="primary-button ipm-submit-btn"
                    type="submit"
                    (click)='confirmVerification()'
                    [disabled]="!otp || 6 > otp?.length">
                    Verify 
                </button>
            </ng-container>
            <ng-template #mobileOtpTemplate> 
                <button mat-flat-button
                    color="primary"
                    class="primary-button ipm-submit-btn"
                    type="submit"
                    (click)='confirmVerification()'
                    [disabled]="isVerificationLocked || !mobileOtp || (userInfo?.channel !== 'sms' && mobileOtp.length !== 6)">
                    Verify 
                </button>
               
            </ng-template>
           
        </div>
    </div>
</div>

